/**
 * Formats the form data to the shape that the API expects
 * @param {Array} data
 * @param {String} type
 * @return {Object} the shape that the API expects
 */
export function formatForAPI(data, type) {
  return Object.keys(data).reduce(
    (prev, id) => {
      const enabled = data[id];

      return {
        [type]: [
          ...prev[type],
          {
            id,
            enabled,
          },
        ],
      };
    },
    {
      [type]: [],
    }
  );
}

/**
 * Formats the API data to the shape the form expects
 * @param {Array} data
 */
export function formatForForm(data) {
  return data.reduce(
    (prev, curr) => ({
      ...prev,
      [curr.id]: curr.enabled,
    }),
    {}
  );
}
